export const iconFontAwesomeShoppingEthereum = (
	<i className="fa-solid fa-ethereum"></i>
);
